const initial = () => {
    $('#menu').click(function() {
        const $menuIcon = $(this);
        const $menuContainer = $('#menu-container');
        $menuIcon.toggleClass('active');

        if ($menuIcon.hasClass('active')) {
            $menuContainer.slideDown('fast');
        } else {
            $menuContainer.stop(true, true).slideUp('fast');
        }
    });
};

export default initial;
